import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import CategoryGrid from './components/CategoryGrid';
import ValueProposition from './components/ValueProposition';
import ComparisonTable from './components/ComparisonTable';
import SEOContent from './components/SEOContent';
import CTASection from './components/CTASection';

export default function Home() {
  return (
    <>
      <script type="application/ld+json">
        {JSON.stringify({
          '@context': 'https://schema.org',
          '@type': 'Organization',
          name: 'Superbuy Spread',
          url: 'https://superbuyspread.xyz',
          logo: 'https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/67defc9f4dfae2c04004e8ea78b88107.png',
          description: 'The ultimate hub for Superbuy Spreadsheet resources including product finds, QC photos, shopping guides, and category databases.',
        })}
      </script>
      <script type="application/ld+json">
        {JSON.stringify({
          '@context': 'https://schema.org',
          '@type': 'WebSite',
          name: 'Superbuy Spread',
          url: 'https://superbuyspread.xyz',
          description: 'The ultimate hub for Superbuy Spreadsheet resources including product finds, QC photos, shopping guides, and category databases.',
          potentialAction: {
            '@type': 'SearchAction',
            target: 'https://superbuyspread.xyz/?q={search_term_string}',
            'query-input': 'required name=search_term_string',
          },
        })}
      </script>
      <script type="application/ld+json">
        {JSON.stringify({
          '@context': 'https://schema.org',
          '@type': 'FAQPage',
          mainEntity: [
            {
              '@type': 'Question',
              name: 'What is Superbuy Spreadsheet?',
              acceptedAnswer: {
                '@type': 'Answer',
                text: 'A Superbuy spreadsheet is an organized product database that consolidates product links, prices, QC photos, sizing information, and community reviews into one accessible format.',
              },
            },
            {
              '@type': 'Question',
              name: 'Is Superbuy Spreadsheet free to use?',
              acceptedAnswer: {
                '@type': 'Answer',
                text: 'Yes, accessing Superbuy spreadsheets through our platform is completely free with 14 organized product categories.',
              },
            },
            {
              '@type': 'Question',
              name: 'Is Superbuy Spreadsheet safe?',
              acceptedAnswer: {
                '@type': 'Answer',
                text: 'Superbuy spreadsheets are safe organizational tools. Users should practice standard online shopping safety by verifying links and using secure payment methods.',
              },
            },
            {
              '@type': 'Question',
              name: 'How often are Superbuy spreadsheets updated?',
              acceptedAnswer: {
                '@type': 'Answer',
                text: 'Our Superbuy spreadsheet categories are updated regularly — typically weekly or bi-weekly — to ensure links remain active and pricing stays current.',
              },
            },
          ],
        })}
      </script>
      <Navbar />
      <main>
        <HeroSection />
        <CategoryGrid />
        <ValueProposition />
        <ComparisonTable />
        <SEOContent />
        <CTASection />
      </main>
      <Footer />
    </>
  );
}